export default __webpack_public_path__ + "static/media/img_cty3.ab17b147.png";